import { useTranslation } from 'react-i18next'
import { CurecallTextButton, PlusIcon } from '@honestica/curecall-ui'

interface AddRangeBetweenButtonProps {
  onClick: () => void
}

export function AddRangeBetweenButton({ onClick }: AddRangeBetweenButtonProps) {
  const { t } = useTranslation()

  return (
    <div className="c-flex c-justify-center c-mt-1 c-animate-fade-in-button">
      <CurecallTextButton
        type="button"
        iconLeft={<PlusIcon className="c-w-4 c-mr-2" />}
        onClick={onClick}
        className="c-text-sm"
      >
        {t('pages.configuration.followups.chatbot.conditional-sections.add-range-between-values')}
      </CurecallTextButton>
    </div>
  )
}
